import { appConfig } from '@/config/app.ts'
import { NestedFilterObject } from '@/core/hooks/useFiltersInBody.ts'

export interface ServiceRechargeInvoicesState {
  isLoading: boolean
  filters: NestedFilterObject
}

export const initialState: ServiceRechargeInvoicesState = {
  isLoading: false,
  filters: {
    limit: appConfig.pagination.defaultValue
  }
}
